import { StudioActionTypes } from './studio.types';

const studioAccountRequest = () => ({ type: StudioActionTypes.STUDIO_ACCOUNT_REQUEST });
const studioAccountSuccess = () => ({ type: StudioActionTypes.STUDIO_ACCOUNT_SUCCESS });
const studioAccountFailure = () => ({ type: StudioActionTypes.STUDIO_ACCOUNT_FAILURE });
const studioAccountSet = payload => ({ type: StudioActionTypes.STUDIO_ACCOUNT_SET, payload });

const studioAccessTrackingRequest = () => ({ type: StudioActionTypes.STUDIO_ACCESS_TRACKING_REQUEST });
const studioAccessTrackingSuccess = () => ({ type: StudioActionTypes.STUDIO_ACCESS_TRACKING_SUCCESS });
const studioAccessTrackingFailure = () => ({ type: StudioActionTypes.STUDIO_ACCESS_TRACKING_FAILURE });

const studioFormCheckRequest = () => ({ type: StudioActionTypes.STUDIO_FORM_CHECK_REQUEST });
const studioFormCheckSuccess = () => ({ type: StudioActionTypes.STUDIO_FORM_CHECK_SUCCESS });
const studioFormCheckFailure = () => ({ type: StudioActionTypes.STUDIO_FORM_CHECK_FAILURE });
const studioFormCheckSet = payload => ({ type: StudioActionTypes.STUDIO_FORM_CHECK_SET, payload });

const studioFormSendRequest = payload => ({ type: StudioActionTypes.STUDIO_FORM_SEND_REQUEST, payload });
const studioFormSendSuccess = () => ({ type: StudioActionTypes.STUDIO_FORM_SEND_SUCCESS });
const studioFormSendFailure = () => ({ type: StudioActionTypes.STUDIO_FORM_SEND_FAILURE });
const studioFormSendSet = payload => ({ type: StudioActionTypes.STUDIO_FORM_SEND_SET, payload });

const studioGetTemplatesForMe = () => ({ type: StudioActionTypes.STUDIO_GET_TEMPLATES_FOR_ME });
const studioGetTemplatesForMeSuccess = () => ({ type: StudioActionTypes.STUDIO_GET_TEMPLATES_FOR_ME_SUCCESS });
const studioGetTemplatesForMeFailure = () => ({ type: StudioActionTypes.STUDIO_GET_TEMPLATES_FOR_ME_FAILURE });
const studioGetTemplatesForMeSet = payload => ({ type: StudioActionTypes.STUDIO_SET_TEMPLATES_FOR_ME, payload });
const studioGetTemplatesForMeLoading = isLoading => ({ type: StudioActionTypes.STUDIO_GET_TEMPLATES_FOR_ME_LOADING, payload: isLoading });

const studioTemplatesRequest = templatesDesired => ({ type: StudioActionTypes.STUDIO_GET_TEMPLATES_REQUEST, payload: templatesDesired });
const studioTemplatesSuccess = () => ({ type: StudioActionTypes.STUDIO_GET_TEMPLATES_SUCCESS });
const studioTemplatesFailure = () => ({ type: StudioActionTypes.STUDIO_GET_TEMPLATES_FAILURE });
const studioTemplatesSet = payload => ({ type: StudioActionTypes.STUDIO_GET_TEMPLATES_SET, payload });
const studioTemplatesLoading = payload => ({ type: StudioActionTypes.STUDIO_GET_TEMPLATES_LOADING, payload });
const studioTemplatesReset = () => ({ type: StudioActionTypes.STUDIO_GET_TEMPLATES_RESET });

const studioProductsRequest = () => ({ type: StudioActionTypes.STUDIO_PRODUCTS_REQUEST });
const studioProductsSuccess = () => ({ type: StudioActionTypes.STUDIO_PRODUCTS_SUCCESS });
const studioProductsFailure = () => ({ type: StudioActionTypes.STUDIO_PRODUCTS_FAILURE });
const studioProductsSet = payload => ({ type: StudioActionTypes.STUDIO_PRODUCTS_SET, payload });
const studioProductsLoading = payload => ({ type: StudioActionTypes.STUDIO_PRODUCTS_LOADING, payload });

const studioRequestProvisionFreePlan = ({ onSuccessCallback } = { onSuccessCallback: null }) => ({ type: StudioActionTypes.STUDIO_REQUEST_PROVISION_FREE_PLAN, payload: { onSuccessCallback } });
const studioProvisionFreePlanSuccess = () => ({ type: StudioActionTypes.STUDIO_REQUEST_PROVISION_FREE_PLAN_SUCCESS });
const studioProvisionFreePlanFailure = () => ({ type: StudioActionTypes.STUDIO_REQUEST_PROVISION_FREE_PLAN_FAILURE });
const studioProvisionFreePlanLoading = payload => ({ type: StudioActionTypes.STUDIO_REQUEST_PROVISION_FREE_PLAN_LOADING, payload });

const studioDocumentCreationRequest = ({
  docType,
  id,
  accessToken,
  popupBlockedAction,
}) => ({
  type: StudioActionTypes.STUDIO_DOCUMENT_CREATION_REQUEST,
  payload: {
    docType,
    id,
    accessToken,
    popupBlockedAction,
  },
});
const studioDocumentCreationSuccess = () => ({ type: StudioActionTypes.STUDIO_DOCUMENT_CREATION_SUCCESS });
const studioDocumentCreationFailure = () => ({ type: StudioActionTypes.STUDIO_DOCUMENT_CREATION_FAILURE });
const studioDocumentCreationLoading = payload => ({ type: StudioActionTypes.STUDIO_DOCUMENT_CREATION_LOADING, payload });

const loading = payload => ({ type: StudioActionTypes.STUDIO_LOADING, payload });

const actions = {
  account: {
    request: studioAccountRequest,
    success: studioAccountSuccess,
    failure: studioAccountFailure,
    set: studioAccountSet,
  },
  accessTracking: {
    request: studioAccessTrackingRequest,
    success: studioAccessTrackingSuccess,
    failure: studioAccessTrackingFailure,
  },
  formCheck: {
    request: studioFormCheckRequest,
    success: studioFormCheckSuccess,
    failure: studioFormCheckFailure,
    set: studioFormCheckSet,
  },
  formSend: {
    request: studioFormSendRequest,
    success: studioFormSendSuccess,
    failure: studioFormSendFailure,
    set: studioFormSendSet,
  },
  forMe: {
    request: studioGetTemplatesForMe,
    success: studioGetTemplatesForMeSuccess,
    failure: studioGetTemplatesForMeFailure,
    set: studioGetTemplatesForMeSet,
    loading: studioGetTemplatesForMeLoading,
  },
  templates: {
    request: studioTemplatesRequest,
    success: studioTemplatesSuccess,
    failure: studioTemplatesFailure,
    set: studioTemplatesSet,
    loading: studioTemplatesLoading,
    reset: studioTemplatesReset,
  },
  products: {
    request: studioProductsRequest,
    success: studioProductsSuccess,
    failure: studioProductsFailure,
    set: studioProductsSet,
    loading: studioProductsLoading,
  },
  provisionFree: {
    request: studioRequestProvisionFreePlan,
    success: studioProvisionFreePlanSuccess,
    failure: studioProvisionFreePlanFailure,
    loading: studioProvisionFreePlanLoading,
  },
  documentCreation: {
    request: studioDocumentCreationRequest,
    success: studioDocumentCreationSuccess,
    failure: studioDocumentCreationFailure,
    loading: studioDocumentCreationLoading,
  },
  loading,
};

export default actions;
